!(function () {
  "use strict";
  var e,
    t = {
      4487: function (e, t, r) {
        var i = r(6072);
        const n = new (class {
          constructor() {
            ((this.selectorsToUpdate = [
              ".cart-summary__header",
              ".cart-summary__line-items",
              "#checkout",
              ".cart-summary__free-shipping",
            ]),
              (this.mainCartSelector = ".shopify-section.cart"),
              (this.miniCart = document.getElementById("mini-cart")),
              (this.itemsContainersSelector =
                ".cart-items-container, .cart__empty, .mini-cart--empty"),
              (this.parser = new DOMParser()),
              (this._desiredQtyByKey = new Map()),
              (this._inFlightByKey = new Set()),
              (this._inventoryBlockedByKey = new Set()),
              (this._maxQtyByKey = new Map()),
              (this._errorTimeoutByKey = new Map()),
              (this._versionByKey = new Map()),
              (this._deletingByKey = new Set()),
              (this.debugMode = !0),
              (this._needsCartRefresh = !1),
              (this.selectors = {
                cartItem: ".cart-item",
                cartItemTotals: ".cart-item__totals",
                priceItemSale: ".price-item--sale",
                priceItemRegular: ".price-item--regular",
                cartItemsContainer: ".cart-items-container",
                miniCart: "#mini-cart",
              }),
              (this.items = Array.from(
                document.querySelectorAll(".cart-item"),
              )),
              this.items.forEach((e) => this.manageState(e)));
          }
          _getCartContainers() {
            const e = [],
              t = document.querySelector(this.mainCartSelector);
            t && e.push({ container: t, name: "mainCart", searchContainer: t });
            const r = document.getElementById("mini-cart");
            if (r) {
              const t = r.querySelector(this.selectors.cartItemsContainer);
              e.push({
                container: r,
                name: "miniCart",
                searchContainer: t || r,
              });
            }
            return e;
          }
          requestQuantityUpdate(e, t) {
            this._desiredQtyByKey.set(e, t);
            const r = this._versionByKey.get(e) || 0;
            this._versionByKey.set(e, r + 1);
            const i = this._maxQtyByKey.get(e);
            (this._inventoryBlockedByKey.has(e) &&
              void 0 !== i &&
              t <= i &&
              (this._inventoryBlockedByKey.delete(e),
              this.clearInventoryError(e)),
              this._inFlightByKey.has(e) || this._processItemUpdate(e));
          }
          async _processItemUpdate(e) {
            this._inFlightByKey.add(e);
            const t = this._desiredQtyByKey.get(e),
              r = this._versionByKey.get(e),
              i = document.querySelector(`.cart-item[data-item-id="${e}"]`);
            if (!i)
              return (
                this._inFlightByKey.delete(e),
                void this._desiredQtyByKey.delete(e)
              );
            const n = i.getAttribute("data-variant-id");
            this._setItemBusy(i, !0);
            try {
              (await this.changeCartItem({
                id: n,
                quantity: t,
                itemKey: e,
                requestVersion: r,
              }),
                this.clearInventoryError(e),
                this._inventoryBlockedByKey.delete(e));
            } catch (t) {
              if ((console.error("Cart update failed:", t), 429 === t.status))
                await new Promise((e) => setTimeout(e, 300));
              else if (422 === t.status) {
                try {
                  const t = `${window.location.pathname}?section_id=main-cart&_ts=${Date.now()}`,
                    r = await fetch(t),
                    i = await r.text(),
                    n = this.parser.parseFromString(i, "text/html"),
                    s = n.querySelector(`.cart-item[data-item-id="${e}"]`);
                  if (s) {
                    const t = s.querySelector('input[name="quantity"]'),
                      r = (t && parseInt(t.value)) || 1;
                    (this._maxQtyByKey.set(e, r),
                      this._desiredQtyByKey.set(e, r),
                      this._inventoryBlockedByKey.add(e),
                      this.showInventoryError(e, `Only ${r} available`),
                      await this.patchLineItem(e, n),
                      this.renderElements(n),
                      this.restoreOptimisticQuantities());
                  }
                } catch (e) {
                  console.error("Failed to fetch cart section after 422:", e);
                }
                return (
                  this._setItemBusy(i, !1),
                  void this._inFlightByKey.delete(e)
                );
              }
            } finally {
              (this._setItemBusy(i, !1), this._inFlightByKey.delete(e));
              const r = this._desiredQtyByKey.get(e);
              void 0 !== r && r !== t && this._processItemUpdate(e);
            }
          }
          _setItemBusy(e, t) {
            e &&
              [
                e.querySelector('button[name="plus"]'),
                e.querySelector('button[name="minus"]'),
                e.querySelector('input[name="quantity"]'),
              ].forEach((e) => {
                e &&
                  (t
                    ? e.classList.add("is-busy")
                    : e.classList.remove("is-busy"));
              });
          }
          async patchLineItem(e, t) {
            let r =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : null;
            try {
              if (!t)
                return void console.error(
                  `[Cart] patchLineItem: parsedSection is null/undefined for ${e}`,
                );
              const i = t.querySelector(
                `${this.selectors.cartItem}[data-item-id="${e}"]`,
              );
              if (!i && !r)
                return void console.warn(
                  `[Cart] patchLineItem: Server item not found for key ${e} and no manual calc data`,
                );
              let n = null;
              if (
                i &&
                ((n = i.querySelector(this.selectors.cartItemTotals)), !n && !r)
              )
                return void console.warn(
                  `[Cart] patchLineItem: Server totals not found for key ${e}`,
                );
              if (r) {
                const i = this._getCartContainers();
                let s = null,
                  o = null;
                for (const { searchContainer: t, name: r } of i) {
                  const r = t.querySelector(
                    `${this.selectors.cartItem}[data-item-id="${e}"]`,
                  );
                  if (r) {
                    let e = r.querySelector(
                        ".text-md.show-desktop " + this.selectors.priceItemSale,
                      ),
                      t = r.querySelector(".text-md.show-desktop s");
                    if (
                      ((e && t) ||
                        ((e = r.querySelector(
                          ".text-md " + this.selectors.priceItemSale,
                        )),
                        (t = r.querySelector(".text-md s"))),
                      !e || !t)
                    ) {
                      const i = r.querySelectorAll(
                        this.selectors.priceItemSale,
                      );
                      for (const r of i)
                        if (!r.closest(this.selectors.cartItemTotals)) {
                          e = r;
                          const i = r.closest("dl, div");
                          i && (t = i.querySelector("s"));
                          break;
                        }
                    }
                    if (e && t) {
                      ((s = e.textContent.trim()), (o = t.textContent.trim()));
                      break;
                    }
                  }
                }
                if (s && o) {
                  const e = (e) => {
                      const t = e.replace(/[^\d.,]/g, "");
                      if (t.includes(",") && !t.includes("."))
                        return parseFloat(t.replace(",", "."));
                      if (t.includes(",") && t.includes(".")) {
                        const e = t.split(",");
                        if (2 === e.length && e[1].length <= 2)
                          return parseFloat(
                            t.replace(/\./g, "").replace(",", "."),
                          );
                      }
                      return parseFloat(t.replace(/,/g, ""));
                    },
                    i = (e(s), e(o) * r.requestedQty),
                    a = r.calculatedLinePrice,
                    c = (e) => {
                      const t = s.match(/[\d,]+\.?\d*/);
                      if (!t) return e.toFixed(2);
                      const r = t[0],
                        i = s.substring(0, s.indexOf(r)),
                        n = s.substring(s.indexOf(r) + r.length),
                        o =
                          s.includes(",") &&
                          (!s.includes(".") || s.indexOf(",") > s.indexOf(".")),
                        a =
                          r.includes(".") || r.includes(",")
                            ? r.split(/[.,]/)[1]?.length || 2
                            : 0;
                      let c = e.toFixed(a);
                      if (o) {
                        c = c.replace(".", ",");
                        const e = c.split(",");
                        (e[0].length > 3 &&
                          (e[0] = e[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".")),
                          (c = e.join(",")));
                      } else {
                        const e = c.split(".");
                        (e[0].length > 3 &&
                          (e[0] = e[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")),
                          (c = e.join(".")));
                      }
                      return i + c + n;
                    },
                    l = `\n            <span class="text-xs show-mobile">Subtotal</span>\n            <span class="total-price">\n              <dl>\n                <dt class="visually-hidden">Regular price</dt>\n                <dd class="price-item--regular">\n                  <s class="text-xs">${c(i)}</s>\n                </dd>\n                <dt class="visually-hidden">Sale price</dt>\n                <dd class="price-item--sale">${c(a)}</dd>\n              </dl>\n            </span>\n          `;
                  n ? (n.innerHTML = l) : (t._calculatedTotalsHTML = l);
                } else
                  console.warn(
                    "[Cart] Could not find per-unit prices for manual calculation",
                  );
              }
              if (!n && !t._calculatedTotalsHTML)
                return void console.warn(
                  "[Cart] patchLineItem: Cannot proceed without serverTotals or calculated HTML",
                );
              let s = null;
              (n
                ? (s = n.innerHTML)
                : t._calculatedTotalsHTML && (s = t._calculatedTotalsHTML),
                this._getCartContainers().forEach((r) => {
                  let { searchContainer: o, name: a } = r;
                  const c = o.querySelector(
                    `${this.selectors.cartItem}[data-item-id="${e}"]`,
                  );
                  if (!c) return;
                  const l = c.querySelector(this.selectors.cartItemTotals);
                  if (l && s) {
                    let e = null,
                      r = null;
                    if (n)
                      ((e = n.querySelector(this.selectors.priceItemSale)),
                        (r = n.querySelector(this.selectors.priceItemRegular)));
                    else if (t._calculatedTotalsHTML) {
                      const i = document.createElement("div");
                      ((i.innerHTML = t._calculatedTotalsHTML),
                        (e = i.querySelector(this.selectors.priceItemSale)),
                        (r = i.querySelector(this.selectors.priceItemRegular)));
                    }
                    const i = l.querySelector(this.selectors.priceItemSale),
                      o = i?.textContent.trim() || null,
                      a =
                        l
                          .querySelector(this.selectors.priceItemRegular)
                          ?.textContent.trim() || null,
                      c = e?.textContent.trim() || null,
                      d = r?.textContent.trim() || null;
                    (o !== c || a !== d || i || e || !i) &&
                      ((l.innerHTML = s),
                      l
                        .querySelectorAll(".icon")
                        .forEach((e) => e.classList.add("loaded")));
                  } else
                    l ||
                      console.warn(
                        `[Cart] patchLineItem: Current totals not found for key ${e} in ${a}`,
                      );
                  if (i) {
                    const e = c.querySelector(".cart-item__discounts"),
                      t = i.querySelector(".cart-item__discounts");
                    if (t)
                      if (e)
                        ((e.innerHTML = t.innerHTML),
                          e
                            .querySelectorAll(".icon")
                            .forEach((e) => e.classList.add("loaded")));
                      else {
                        const e = c.querySelector(".cart-item__title");
                        if (e) {
                          const r = t.cloneNode(!0);
                          (e.appendChild(r),
                            r
                              .querySelectorAll(".icon")
                              .forEach((e) => e.classList.add("loaded")));
                        }
                      }
                    else e && e.remove();
                  }
                }));
            } catch (t) {
              (console.error(`[Cart] Error in patchLineItem for ${e}:`, t),
                console.error("[Cart] Error stack:", t.stack));
            }
          }
          restoreOptimisticQuantities() {
            this._desiredQtyByKey.forEach((e, t) => {
              this._inventoryBlockedByKey.has(t) ||
                this._getCartContainers().forEach((r) => {
                  let { searchContainer: i } = r;
                  const n = i.querySelector(
                    `${this.selectors.cartItem}[data-item-id="${t}"]`,
                  );
                  if (!n) return;
                  const s = n.querySelector('input[name="quantity"]');
                  if (!s) return;
                  const o = this._maxQtyByKey.get(t),
                    a = void 0 !== o ? Math.min(e, o) : e;
                  (parseInt(s.value) || 1) !== a && (s.value = a);
                });
            });
          }
          showInventoryError(e, t) {
            const r = this._errorTimeoutByKey.get(e);
            (r && clearTimeout(r),
              this._getCartContainers().forEach((r) => {
                let { searchContainer: i } = r;
                const n = i.querySelector(
                  `${this.selectors.cartItem}[data-item-id="${e}"]`,
                );
                if (!n) return;
                const s = n.querySelector(".cart-item__error");
                s && ((s.textContent = t), (s.style.display = "block"));
              }));
            const i = setTimeout(() => {
              const r = this._desiredQtyByKey.get(e),
                i = this._maxQtyByKey.get(e);
              void 0 === r || void 0 === i || r <= i
                ? this.clearInventoryError(e)
                : this.showInventoryError(e, t);
            }, 4e3);
            this._errorTimeoutByKey.set(e, i);
          }
          clearInventoryError(e) {
            const t = this._errorTimeoutByKey.get(e);
            (t && (clearTimeout(t), this._errorTimeoutByKey.delete(e)),
              this._getCartContainers().forEach((t) => {
                let { searchContainer: r } = t;
                const i = r.querySelector(
                  `${this.selectors.cartItem}[data-item-id="${e}"]`,
                );
                if (!i) return;
                const n = i.querySelector(".cart-item__error");
                n && ((n.textContent = ""), (n.style.display = "none"));
              }));
          }
          _removeDeleteClass(e) {
            this._getCartContainers().forEach((t) => {
              let { searchContainer: r } = t;
              const i = r.querySelector(
                `${this.selectors.cartItem}[data-item-id="${e}"]`,
              );
              i && i.classList.remove("is-deleting");
            });
          }
          _animateItemRemoval(e) {
            return new Promise((t) => {
              if (!e) return void t();
              if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
                return (e.remove(), void t());
              const r = e.offsetHeight;
              ((e.style.height = `${r}px`),
                (e.style.overflow = "hidden"),
                e.setAttribute("aria-live", "polite"),
                e.setAttribute("aria-atomic", "true"),
                e.offsetHeight,
                requestAnimationFrame(() => {
                  (e.classList.add("cart-item--removing"),
                    setTimeout(() => {
                      (e.remove(), t());
                    }, 300));
                }));
            });
          }
          removeEventListeners(e) {
            const t = e.querySelector(".cart-item-delete, .cart-item__remove"),
              r = e.querySelector('button[name="plus"]'),
              i = e.querySelector('button[name="minus"]'),
              n = e.querySelector('input[name="quantity"]');
            (t &&
              t._deleteHandler &&
              t.removeEventListener("click", t._deleteHandler),
              r &&
                r._clickHandler &&
                r.removeEventListener("click", r._clickHandler),
              i &&
                i._clickHandler &&
                i.removeEventListener("click", i._clickHandler),
              n &&
                (n._changeHandler &&
                  n.removeEventListener("change", n._changeHandler),
                n._keypressHandler &&
                  n.removeEventListener("keypress", n._keypressHandler)));
          }
          manageState(e) {
            this.removeEventListeners(e);
            const t = e.getAttribute("data-item-id"),
              r = e.getAttribute("data-variant-id"),
              i = e.getAttribute("data-max-qty");
            if (i && !this._maxQtyByKey.has(t)) {
              const e = parseInt(i);
              !isNaN(e) && e > 0 && this._maxQtyByKey.set(t, e);
            }
            const n = e.querySelector(".cart-item-delete, .cart-item__remove");
            if (n) {
              const e = async () => {
                if (this._deletingByKey.has(t))
                  this.debugMode &&
                    console.log(
                      `[Cart] Delete already in progress for ${t}, ignoring duplicate request`,
                    );
                else
                  try {
                    (this._deletingByKey.add(t),
                      this._getCartContainers().forEach((e) => {
                        let { searchContainer: r } = e;
                        const i = r.querySelector(
                          `${this.selectors.cartItem}[data-item-id="${t}"]`,
                        );
                        i && i.classList.add("is-deleting");
                      }),
                      console.log(`[Cart] Starting delete for ${t}`),
                      console.log(
                        `[Cart] Fetching current cart state to find correct line number for ${t}`,
                      ));
                    const e = await fetch("/cart.js"),
                      i = (await e.json()).items.findIndex((e) => e.key === t);
                    if (-1 === i)
                      return (
                        console.warn(
                          `[Cart] Item ${t} not found in current cart, may already be deleted`,
                        ),
                        void this._getCartContainers().forEach((e) => {
                          let { searchContainer: r } = e;
                          const i = r.querySelector(
                            `${this.selectors.cartItem}[data-item-id="${t}"]`,
                          );
                          i && i.remove();
                        })
                      );
                    const n = i + 1;
                    let s;
                    console.log(
                      `[Cart] Item ${t} is at line ${n} (was stored as line ${r})`,
                    );
                    try {
                      ((s = await this.changeCartItem({ id: n, quantity: 0 })),
                        console.log(
                          "[Cart] Delete request successful, response:",
                          s,
                        ));
                    } catch (e) {
                      if (
                        (console.error(
                          `[Cart] changeCartItem failed for ${t}:`,
                          e,
                        ),
                        429 !== e.status)
                      )
                        return 422 === e.status
                          ? (console.error(
                              `[Cart] Server validation error (422) for ${t} - item NOT deleted, keeping in cart`,
                            ),
                            void this._removeDeleteClass(t))
                          : (console.error(
                              `[Cart] Unexpected error for ${t} - item may still be in cart`,
                            ),
                            void this._removeDeleteClass(t));
                      (console.warn(
                        `[Cart] Rate limited (429) for ${t}, waiting 500ms then retrying...`,
                      ),
                        await new Promise((e) => setTimeout(e, 500)));
                      try {
                        ((s = await this.changeCartItem({
                          id: r,
                          quantity: 0,
                        })),
                          this.debugMode &&
                            console.log(
                              `[Cart] Retry after rate limit successful for ${t}`,
                            ));
                      } catch (e) {
                        return (
                          console.error(`[Cart] Retry failed for ${t}:`, e),
                          void this._removeDeleteClass(t)
                        );
                      }
                    }
                    if (s) {
                      const e = 0 === s.item_count;
                      this.debugMode &&
                        console.log(
                          `[Cart] Removing item ${t} from all containers (${s.item_count} items remain, isLastItem: ${e})`,
                        );
                      const r = this._getCartContainers();
                      this.debugMode &&
                        console.log(
                          `[Cart] Found ${r.length} cart containers to update`,
                        );
                      const i = r.map((e) => {
                        let { searchContainer: r, name: i } = e;
                        const n = r.querySelector(
                          `${this.selectors.cartItem}[data-item-id="${t}"]`,
                        );
                        return n
                          ? (this.debugMode &&
                              console.log(
                                `[Cart] Removing item ${t} from ${i}`,
                              ),
                            this._animateItemRemoval(n))
                          : (this.debugMode &&
                              console.log(`[Cart] Item ${t} not found in ${i}`),
                            Promise.resolve());
                      });
                      (await Promise.all(i),
                        this._desiredQtyByKey.delete(t),
                        this._inFlightByKey.delete(t),
                        this._inventoryBlockedByKey.delete(t),
                        this._maxQtyByKey.delete(t),
                        this._versionByKey.delete(t));
                      const n = this._errorTimeoutByKey.get(t);
                      (n &&
                        (clearTimeout(n), this._errorTimeoutByKey.delete(t)),
                        e &&
                          this.debugMode &&
                          console.log(
                            "[Cart] Last item removed, empty state should be visible",
                          ));
                    } else
                      console.error(
                        "[Cart] Delete operation failed - no response received",
                      );
                  } catch (e) {
                    console.error(`[Cart] Error deleting item ${t}:`, e);
                  } finally {
                    (this._deletingByKey.delete(t),
                      this.debugMode &&
                        console.log(
                          `[Cart] Delete operation completed for ${t}`,
                        ));
                  }
              };
              ((n._deleteHandler = e), n.addEventListener("click", e));
            }
            if (!e.querySelector('input[name="quantity"]')) return;
            const s = e.querySelector('button[name="plus"]'),
              o = e.querySelector('button[name="minus"]'),
              a = e.querySelector('input[name="quantity"]'),
              c = () => {
                const e = parseInt(a.value) || 1,
                  r = this._maxQtyByKey.get(t),
                  i = void 0 !== r ? Math.min(r, e + 1) : e + 1;
                i !== e || void 0 === r
                  ? ((a.value = i), this.requestQuantityUpdate(t, i))
                  : this.showInventoryError(t, `Only ${r} available`);
              },
              l = () => {
                const e = parseInt(a.value) || 1,
                  r = Math.max(1, e - 1);
                r !== e && ((a.value = r), this.requestQuantityUpdate(t, r));
              },
              d = (e) => {
                const r = parseInt(e.target.value);
                let i = isNaN(r) || r < 1 ? 1 : r;
                const n = parseInt(a.value) || 1,
                  s = this._maxQtyByKey.get(t);
                (void 0 !== s &&
                  i > s &&
                  ((i = s), this.showInventoryError(t, `Only ${s} available`)),
                  (i === n && a.value === String(i)) ||
                    ((a.value = i), this.requestQuantityUpdate(t, i)));
              },
              u = (e) => {
                ((8 !== e.which && 0 !== e.which && e.which < 48) ||
                  e.which > 57) &&
                  e.preventDefault();
              };
            (s && ((s._clickHandler = c), s.addEventListener("click", c)),
              o && ((o._clickHandler = l), o.addEventListener("click", l)),
              (a._changeHandler = d),
              a.addEventListener("change", d),
              (a._keypressHandler = u),
              a.addEventListener("keypress", u));
          }
          async changeCartItem(e) {
            const t = {
              ...(0, i.Q2)(),
              body: JSON.stringify({
                line: +e.id,
                quantity: e.quantity,
                sections: "main-cart",
              }),
            };
            return fetch(`${routes.cartChange}`, t)
              .then((e) => {
                if (!e.ok && 429 === e.status) {
                  const e = new Error("Rate limited");
                  throw ((e.status = 429), e);
                }
                if (!e.ok && 422 === e.status) {
                  const e = new Error("Item already deleted or invalid");
                  throw ((e.status = 422), e);
                }
                if (!e.ok) throw new Error(`HTTP error! status: ${e.status}`);
                return e.json();
              })
              .then(async (t) => {
                const r = async (r, i) => {
                  let n = this.parser.parseFromString(r, "text/html");
                  if (i && t.item_count > 0) {
                    const t = n.querySelector(
                        `.cart-item[data-item-id="${i}"]`,
                      ),
                      r = t && t.querySelector(".cart-item__totals"),
                      s = r && r.querySelector(".price-item--sale"),
                      o = document.querySelector(
                        `.cart-item[data-item-id="${i}"]`,
                      ),
                      a = o && o.querySelector(".cart-item__totals"),
                      c = a && a.querySelector(".price-item--sale");
                    if (s || c) {
                      const r = e.quantity,
                        s = t && t.querySelector('input[name="quantity"]'),
                        o = (s && parseInt(s.value)) || 1;
                      if (t && o === r);
                      else {
                        const e = this._getCartContainers();
                        let t = null;
                        for (const { searchContainer: r } of e) {
                          const e = r.querySelector(
                            `${this.selectors.cartItem}[data-item-id="${i}"]`,
                          );
                          if (e) {
                            let r = e.querySelector(
                              ".text-md.show-desktop " +
                                this.selectors.priceItemSale,
                            );
                            if (
                              (r ||
                                (r = e.querySelector(
                                  ".text-md " + this.selectors.priceItemSale,
                                )),
                              !r)
                            ) {
                              const t = e.querySelectorAll(
                                this.selectors.priceItemSale,
                              );
                              for (const e of t)
                                if (!e.closest(this.selectors.cartItemTotals)) {
                                  r = e;
                                  break;
                                }
                            }
                            if (r) {
                              const e = r.textContent
                                .trim()
                                .replace(/[^\d.,]/g, "");
                              if (e.includes(",") && !e.includes("."))
                                t = parseFloat(e.replace(",", "."));
                              else if (e.includes(",") && e.includes(".")) {
                                const r = e.split(",");
                                t =
                                  2 === r.length && r[1].length <= 2
                                    ? parseFloat(
                                        e.replace(/\./g, "").replace(",", "."),
                                      )
                                    : parseFloat(e.replace(/,/g, ""));
                              } else t = parseFloat(e.replace(/,/g, ""));
                              if (!isNaN(t)) break;
                            }
                          }
                        }
                        if (null !== t) {
                          const e = t * r;
                          ((n._needsManualPriceCalc = !0),
                            (n._calculatedLinePrice = e),
                            (n._requestedQty = r));
                        }
                      }
                    }
                  }
                  if (0 === t.item_count) {
                    console.log("[Cart] Cart is empty, rendering empty state");
                    const e = document.querySelector(this.mainCartSelector);
                    if (e) {
                      const t = n.querySelector(this.mainCartSelector);
                      t
                        ? (console.log(
                            "[Cart] Updating main cart with empty state HTML",
                          ),
                          (e.innerHTML = t.innerHTML))
                        : console.warn(
                            `[Cart] Could not find main cart selector "${this.mainCartSelector}" in parsed content`,
                          );
                    } else
                      console.log("[Cart] No main cart element found on page");
                    this.renderElements(n);
                  } else if ((this.renderElements(n), i)) {
                    const e = n._needsManualPriceCalc
                      ? {
                          calculatedLinePrice: n._calculatedLinePrice,
                          requestedQty: n._requestedQty,
                        }
                      : null;
                    await this.patchLineItem(i, n, e);
                  }
                  this.restoreOptimisticQuantities();
                };
                if (t.sections && null !== t.sections["main-cart"])
                  await r(t.sections["main-cart"], e.itemKey);
                else {
                  const t = `${window.location.pathname}?section_id=main-cart&_ts=${Date.now()}`;
                  await fetch(t)
                    .then((e) => e.text())
                    .then(async (t) => {
                      await r(t, e.itemKey);
                    });
                }
                const i = `${window.location.pathname}?section_id=navigation-main`;
                return fetch(i)
                  .then((e) => e.text())
                  .then((e) => {
                    if (
                      (this.parser.parseFromString(e, "text/html"),
                      0 === t.item_count)
                    ) {
                      console.log(
                        "[Cart] Cart is now empty, manually updating mini-cart to empty state",
                      );
                      const e = document.querySelector("#mini-cart");
                      if (e) {
                        const t = e.querySelector(".cart-items-container");
                        t &&
                          (console.log("[Cart] Hiding cart-items-container"),
                          (t.style.display = "none"),
                          t.remove());
                        let r = e.querySelector(".mini-cart--empty");
                        if (r)
                          (console.log(
                            "[Cart] Found existing mini-cart--empty, making it visible",
                          ),
                            (r.style.display = "block"));
                        else {
                          console.log(
                            "[Cart] No mini-cart--empty found, checking mini-cart__content",
                          );
                          const t = e.querySelector(".mini-cart__content");
                          t &&
                            ((r = t.querySelector(".mini-cart--empty")),
                            r &&
                              (console.log(
                                "[Cart] Found mini-cart--empty in content, making visible",
                              ),
                              (r.style.display = "block")));
                        }
                        (e.querySelectorAll(".cart-count").forEach((e) => {
                          e.textContent = "0";
                        }),
                          e
                            .querySelectorAll(".cart-total-price")
                            .forEach((e) => {
                              e.textContent = "$0.00";
                            }));
                        const i = e.querySelector("#checkout");
                        i && (i.disabled = !0);
                        const n = e.querySelector(
                          ".cart-summary__free-shipping",
                        );
                        (n &&
                          ((n.style.display = "none"),
                          console.log(
                            "[Cart] Hidden free shipping calculator for empty cart",
                          )),
                          console.log(
                            "[Cart] ✓ Mini-cart manually updated to empty state",
                          ));
                      } else
                        console.log(
                          "[Cart] No mini-cart element found on page",
                        );
                    }
                    return t;
                  });
              })
              .catch((e) => {
                throw (console.error(e), e);
              });
          }
          renderElements(e) {
            this.selectorsToUpdate.forEach((t) => {
              try {
                const r = document.querySelectorAll(t),
                  i = e.querySelector(t);
                r.length &&
                  i &&
                  (i
                    .querySelectorAll(".icon")
                    .forEach((e) => e.classList.add("loaded")),
                  r.forEach((e) => {
                    e.innerHTML = i.innerHTML;
                    if (i.hasAttribute("disabled")) {
                      e.setAttribute("disabled", "disabled");
                    } else {
                      e.removeAttribute("disabled");
                    }
                  }));
              } catch (e) {
                console.error(`Error updating ${t}`, e);
              }
            });
            const t = e.querySelector(".cart-total-price");
            if (t) {
              const e = [],
                r = document.querySelector(this.mainCartSelector);
              (r && e.push(r),
                this.miniCart && e.push(this.miniCart),
                e.forEach((e) => {
                  const r = e.querySelector(".cart-total-price");
                  r && (r.innerHTML = t.innerHTML);
                }));
            }
            const r = e.querySelector(".cart-count");
            (document
              .querySelectorAll(
                "#cart-open-block .header__icons--cart-open .cart-count",
              )
              .forEach((e) => {
                r
                  ? (e.classList.contains("visually-hidden") &&
                      e.classList.remove("visually-hidden"),
                    (e.textContent = r.textContent))
                  : e.classList.add("visually-hidden");
              }),
              document
                .querySelector("#cart-open-block .icon")
                .classList.add("loaded"));
          }
          renderItems(e) {
            this.renderElements(e);
            const t = Array.from(
                document.querySelectorAll(this.itemsContainersSelector),
              ),
              r = e.querySelector(this.itemsContainersSelector);
            (t.forEach((e) => {
              e && e.replaceWith(r.cloneNode(!0));
            }),
              document.querySelectorAll(".cart-item").forEach((e) => {
                (e
                  .querySelectorAll(".icon")
                  .forEach((e) => e.classList.add("loaded")),
                  this.manageState(e));
              }));
          }
          updateMiniCart(e) {
            return fetch(
              `${window.location.pathname}?section_id=main-cart&_ts=${Date.now()}`,
            )
              .then((e) => e.text())
              .then((t) => {
                (this.renderItems(
                  new DOMParser().parseFromString(t, "text/html"),
                ),
                  e &&
                    "mini-cart" === cartStrings.uxCart &&
                    this.miniCart &&
                    this.miniCart.open());
              })
              .catch((e) => {
                console.error("Error updating mini cart:", e);
              });
          }
        })();
        ((window.cartService = n),
          (window.updateMiniCart = function () {
            return n.updateMiniCart(...arguments);
          }),
          (t.Z = n),
          customElements.get("cart-note") ||
            customElements.define(
              "cart-note",
              class extends HTMLElement {
                constructor() {
                  (super(),
                    this.querySelector("textarea").addEventListener(
                      "change",
                      (0, i.Ds)((e) => {
                        const t = JSON.stringify({ note: e.target.value });
                        fetch(`${routes.cartUpdate}`, {
                          ...(0, i.Q2)(),
                          body: t,
                        });
                      }, 300),
                    ));
                }
              },
            ));
      },
      9893: function (e, t, r) {
        var i = r(3643),
          n = r(1717);
        const s = (e) => {
            const t = e.dataset.url;
            fetch(t)
              .then((e) => e.text())
              .then((t) => {
                const r = document.createElement("div");
                r.innerHTML = t;
                const s = r.querySelector(".product-recommendations");
                if (s && s.innerHTML.trim().length) {
                  const t = e.closest(".shopify-section");
                  (t.classList.add("u-hide"),
                    (e.innerHTML = s.innerHTML),
                    new i.M(),
                    (0, n.f)(),
                    setTimeout(() => {
                      t.classList.remove("u-hide");
                    }, 1e3));
                }
              })
              .catch((e) => {
                console.error(e);
              });
          },
          o = document.querySelectorAll(".product-recommendations"),
          a = new IntersectionObserver(
            (e, t) => {
              e.forEach((e) => {
                e.isIntersecting && (t.unobserve(e.target), s(e.target));
              });
            },
            { rootMargin: "0px 0px 200px 0px" },
          );
        (o.forEach((e) => {
          a.observe(e);
        }),
          Shopify.designMode &&
            document.addEventListener("shopify:section:load", () => {
              o.forEach((e) => {
                s(e);
              });
            }));
      },
      1717: function (e, t, r) {
        r.d(t, {
          f: function () {
            return s;
          },
        });
        var i = r(6072),
          n = r(4487);
        const s = () => {
          const e = document.querySelectorAll(
              'form[data-type="add-to-cart-form"]',
            ),
            t = document.getElementById("main-cart"),
            r = document.getElementById("mini-cart"),
            s = document.querySelector("body");
          e.length &&
            e.forEach((e) => {
              if (e.dataset.cartFormInitialized) return;
              e.dataset.cartFormInitialized = '1';
              e.addEventListener("submit", (o) => {
                (o.preventDefault(),
                  o.stopPropagation(),
                  o.target.querySelector(
                    'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                  ) &&
                    (o.target.querySelector(
                      'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                    ).textContent = `${cartStrings.addingToCart}`));
                const a = o.target.querySelector('button[type="submit"]'),
                  c = a.querySelector("span.cart-icon"),
                  l = a.querySelector("svg.loading-icon");
                (s.classList.remove("added-to-cart"),
                  a.classList.add("added"),
                  c && (c.style.display = "none"),
                  l && (l.style.display = "block"));
                const d = (0, i.Q2)("javascript");
                ((d.headers["X-Requested-With"] = "XMLHttpRequest"),
                  delete d.headers["Content-Type"]);
                const u = new FormData(e);
                (u.append("sections", "main-cart"),
                  (d.body = u),
                  fetch(`${routes.cartAdd}`, d)
                    .then((e) => e.json())
                    .then(async (e) => {
                      if (e.status) {
                        if (
                          (n.Z.updateMiniCart(!0),
                          c && (c.style.display = "inline-flex"),
                          l && (l.style.display = "none"),
                          o.target.querySelector(
                            'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                          ) &&
                            (o.target.querySelector(
                              'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                            ).textContent = `${cartStrings.addToCart}`),
                          "object" == typeof e.description)
                        )
                          return Object.entries(e.description).forEach((e) => {
                            let [t, r] = e;
                            const i = `${r.join(", ")}`;
                            const errEl1 = o.target.querySelector(
                              ".main-product__error",
                            );
                            if (errEl1) errEl1.innerHTML =
                              '<span class="icon loaded">error</span><p>' +
                              i +
                              "</p>";
                          });
                        const errEl2 = o.target.querySelector(
                          ".main-product__error",
                        );
                        if (errEl2) errEl2.innerHTML =
                          '<span class="icon loaded">error</span><p>' +
                          e.description +
                          "</p>";
                      } else {
                        if ("cart" === cartStrings.uxCart)
                          return void (window.location.href =
                            window.routes.cart);
                        if (
                          ((() => { const errEl3 = o.target.querySelector(".main-product__error"); if (errEl3) errEl3.innerHTML = ""; })(),
                          t && t.classList.add("added"),
                          e.sections && null !== e.sections["main-cart"])
                        )
                          n.Z.renderItems(
                            new DOMParser().parseFromString(
                              e.sections["main-cart"],
                              "text/html",
                            ),
                          );
                        else {
                          const e = `${window.location.pathname}?section_id=main-cart`;
                          fetch(e)
                            .then((e) => e.text())
                            .then((e) => {
                              n.Z.renderItems(
                                new DOMParser().parseFromString(e, "text/html"),
                              );
                            });
                        }
                        ("mini-cart" === cartStrings.uxCart && r && r.open(),
                          o.target.querySelector(
                            'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                          ) &&
                            (o.target.querySelector(
                              'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                            ).textContent = `${cartStrings.addedToCart}`),
                          a.classList.remove("added"),
                          a.classList.add("successful"),
                          c && (c.style.display = "flex"),
                          l && (l.style.display = "none"),
                          s.classList.add("added-to-cart"));
                      }
                    })
                    .catch((e) => {
                      console.error("Error:", e);
                    }));
              });
            });
        };
      },
      3643: function (e, t, r) {
        (r.d(t, {
          M: function () {
            return i;
          },
        }),
          (0, r(2994).z2)());
        class i {
          constructor() {
            (this.initializeSwipers(),
              Shopify.designMode &&
                document.addEventListener("shopify:section:load", () =>
                  this.initializeSwipers(),
                ));
          }
          initializeSwipers() {
            document.querySelectorAll("swiper-container").forEach((e) => {
              e.dataset.mobileSlidesPerView;
              const t =
                  (e.dataset.desktopSlidesPerView,
                  "0" !== e.dataset.tabletSlidesPerView &&
                    e.dataset.tabletSlidesPerView &&
                    e.dataset.tabletSlidesPerView,
                  "true" === e.dataset.textPagination),
                r = Number(e.dataset.spaceBetweenMobile) || 16,
                i = Number(e.dataset.spaceBetweenTablet) || 32,
                n = Number(e.dataset.spaceBetweenDesktop) || 32,
                s = e.dataset.mobileLayout || "slider",
                o = e.dataset.desktopLayout || "slider",
                a = window.matchMedia(
                  "(min-width: 0px) and (max-width: 1023px)",
                ),
                c = window.matchMedia("(min-width: 1024px)"),
                l = () => {
                  (e.querySelectorAll("video").forEach((e) => {
                    e.classList.contains("section__wrapper-background") ||
                      e.pause();
                  }),
                    Array.from(e.querySelectorAll("swiper-slide"))
                      .filter((e) =>
                        e.classList.contains("swiper-slide-visible"),
                      )
                      .forEach((e) => {
                        const t = e.querySelector("video");
                        t && t.hasAttribute("autoplay") && t.play();
                      }));
                },
                d = () => {
                  const t = e.closest(".slideshow-text-controls__wrapper");
                  if (!t) return;
                  const r = e.swiper.slides[e.swiper.realIndex];
                  if (!r) return;
                  const i = r.getAttribute("data-slide");
                  t.querySelectorAll(".slideshow-text-controls__item").forEach(
                    (e) => {
                      e.classList.toggle(
                        "active",
                        e.getAttribute("data-slide") === i,
                      );
                    },
                  );
                },
                u = () => {
                  if (
                    (c.matches && "slider" === o) ||
                    (a.matches && "slider" === s)
                  )
                    if (!e.swiper || e.swiper.destroyed) {
                      const s =
                          parseFloat(e.dataset.mobileSlidesPerView) || "auto",
                        o =
                          "0" !== e.dataset.tabletSlidesPerView &&
                          e.dataset.tabletSlidesPerView
                            ? parseFloat(e.dataset.tabletSlidesPerView)
                            : s,
                        a =
                          parseFloat(e.dataset.desktopSlidesPerView) || "auto",
                        c = {
                          ...(e.parentElement?.classList.contains("card__image")
                            ? { virtual: { enabled: !0 }, nested: !0 }
                            : {}),
                          breakpoints: {
                            0: { slidesPerView: s, spaceBetween: parseInt(r) },
                            768: {
                              slidesPerView: o,
                              spaceBetween: parseInt(i),
                            },
                            1024: {
                              slidesPerView: a,
                              spaceBetween: parseInt(n),
                            },
                          },
                        };
                      (Object.assign(e, c),
                        e.addEventListener("swiperafterinit", () => {
                          const t = e.closest(".shopify-section");
                          (t && t.classList.add("slider-enabled"),
                            setTimeout(() => {
                              if (!e.swiper) return;
                              const t = e.swiper?.slides?.length || 0,
                                r = t < s ? t : s,
                                i = t < o ? t : o,
                                n = t < a ? t : a;
                              (e.swiper &&
                                e.swiper.params &&
                                e.swiper.params.breakpoints &&
                                ((e.swiper.currentBreakpoint = !1),
                                (e.swiper.params.breakpoints[0].slidesPerView =
                                  r),
                                (e.swiper.params.breakpoints[768].slidesPerView =
                                  i),
                                (e.swiper.params.breakpoints[992].slidesPerView =
                                  n),
                                e.swiper.update(),
                                e.swiper.slideTo(0, 0, !1)),
                                l(),
                                (() => {
                                  const t = e
                                    .closest(".main-product__media-wrapper")
                                    ?.querySelector(
                                      ".swiper-thumbnails .swiper",
                                    );
                                  t &&
                                    (Object.assign(t, {
                                      direction: "vertical",
                                      slidesPerView: "auto",
                                      spaceBetween: 8,
                                      watchSlidesProgress: !0,
                                      navigation: {
                                        nextEl: ".swiper-button-thumbs-next",
                                        prevEl: ".swiper-button-thumbs-prev",
                                      },
                                      breakpoints: {
                                        0: {
                                          direction: "horizontal",
                                          slidesPerView: 4,
                                        },
                                        768: {
                                          direction: "vertical",
                                          slidesPerView: "auto",
                                        },
                                      },
                                    }),
                                    t.initialize());
                                })());
                            }, 0));
                        }),
                        e.addEventListener("swiperslidechange", () => {
                          (l(), d());
                        }),
                        e.addEventListener("swiperdestroy", () => {
                          const t = e.closest(".shopify-section");
                          t && t.classList.remove("slider-enabled");
                        }),
                        e.addEventListener("swiperlock", () => {
                          const t = e.closest(".shopify-section");
                          t &&
                            !t.classList.contains("recommended-products") &&
                            setTimeout(() => {
                              t.querySelectorAll(
                                ".grid-content__slider-nav",
                              ).forEach((e) => {
                                e.style.display = "none";
                              });
                            }, 1);
                        }),
                        e.initialize(),
                        t &&
                          ((() => {
                            if (!t) return;
                            const r = e.closest(
                              ".slideshow-text-controls__wrapper",
                            );
                            r &&
                              r
                                .querySelectorAll(
                                  ".slideshow-text-controls__item",
                                )
                                .forEach((t) => {
                                  t.addEventListener("click", () => {
                                    const r = t.getAttribute("data-slide"),
                                      i = Array.from(e.swiper.slides).findIndex(
                                        (e) =>
                                          e.getAttribute("data-slide") === r,
                                      );
                                    -1 !== i && e.swiper.slideTo(i);
                                  });
                                });
                          })(),
                          d()));
                    } else e.swiper.update();
                  else if ((Object.assign(e), e.initialize(), e.swiper)) {
                    e.swiper.destroy(!0, !0);
                    const t = e.closest(".shopify-section");
                    t && t.classList.remove("slider-enabled");
                  }
                };
              (window.addEventListener("resize", u), u());
            });
          }
        }
        new i();
      },
      6072: function (e, t, r) {
        r.d(t, {
          Ds: function () {
            return n;
          },
          Q2: function () {
            return i;
          },
        });
        const i = function () {
          return {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: `application/${arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "json"}`,
            },
          };
        };
        function n(e, t) {
          const r = this;
          let i;
          return function () {
            for (var n = arguments.length, s = new Array(n), o = 0; o < n; o++)
              s[o] = arguments[o];
            (clearTimeout(i),
              (i = setTimeout(function () {
                return e.apply(r, s);
              }, t)));
          };
        }
        document.querySelectorAll(".local-scroll").forEach((e) => {
          e.addEventListener("click", (e) => {
            (e.preventDefault(), e.stopPropagation());
            const t = e.target.getAttribute("href");
            !(function (e) {
              let t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : 0;
              const r = document.getElementById("nav-wrapper"),
                i = document
                  .querySelector(".header")
                  .getAttribute("data-ux-position"),
                n = e.getBoundingClientRect().top;
              window.scrollTo({
                top:
                  "off" !== i
                    ? n + window.scrollY - t + parseFloat(r.style.marginTop)
                    : n + window.scrollY - t,
                behavior: "smooth",
              });
            })(document.querySelector(t));
          });
        });
      },
    },
    r = {};
  function i(e) {
    var n = r[e];
    if (void 0 !== n) return n.exports;
    var s = (r[e] = { exports: {} });
    return (t[e](s, s.exports, i), s.exports);
  }
  ((i.m = t),
    (e = []),
    (i.O = function (t, r, n, s) {
      if (!r) {
        var o = 1 / 0;
        for (d = 0; d < e.length; d++) {
          ((r = e[d][0]), (n = e[d][1]), (s = e[d][2]));
          for (var a = !0, c = 0; c < r.length; c++)
            (!1 & s || o >= s) &&
            Object.keys(i.O).every(function (e) {
              return i.O[e](r[c]);
            })
              ? r.splice(c--, 1)
              : ((a = !1), s < o && (o = s));
          if (a) {
            e.splice(d--, 1);
            var l = n();
            void 0 !== l && (t = l);
          }
        }
        return t;
      }
      s = s || 0;
      for (var d = e.length; d > 0 && e[d - 1][2] > s; d--) e[d] = e[d - 1];
      e[d] = [r, n, s];
    }),
    (i.d = function (e, t) {
      for (var r in t)
        i.o(t, r) &&
          !i.o(e, r) &&
          Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    }),
    (i.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (i.j = 6184),
    (function () {
      var e = { 6184: 0, 7658: 0, 7954: 0, 9217: 0, 3625: 0 };
      i.O.j = function (t) {
        return 0 === e[t];
      };
      var t = function (t, r) {
          var n,
            s,
            o = r[0],
            a = r[1],
            c = r[2],
            l = 0;
          if (
            o.some(function (t) {
              return 0 !== e[t];
            })
          ) {
            for (n in a) i.o(a, n) && (i.m[n] = a[n]);
            if (c) var d = c(i);
          }
          for (t && t(r); l < o.length; l++)
            ((s = o[l]), i.o(e, s) && e[s] && e[s][0](), (e[s] = 0));
          return i.O(d);
        },
        r = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
      (r.forEach(t.bind(null, 0)), (r.push = t.bind(null, r.push.bind(r))));
    })());
  var n = i.O(void 0, [1216], function () {
    return i(9893);
  });
  n = i.O(n);
})();
